module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "time-usage"
  }, [_c('div', {
    staticClass: "employee-switcher"
  }, [_c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.employeeWorkingFieldName === ''
    },
    on: {
      "click": function($event) {
        _vm.employeeWorkingFieldName = ''
      }
    }
  }, [_vm._v("\n            Alle medarbejdere\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.employeeWorkingFieldName === 'Svend, funktionær'
    },
    on: {
      "click": function($event) {
        _vm.employeeWorkingFieldName = 'Svend, funktionær'
      }
    }
  }, [_vm._v("\n            Svende, funktionær\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.employeeWorkingFieldName === 'Svend, timelønnet'
    },
    on: {
      "click": function($event) {
        _vm.employeeWorkingFieldName = 'Svend, timelønnet'
      }
    }
  }, [_vm._v("\n            Svende, timelønnet\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.employeeWorkingFieldName === 'Lærling'
    },
    on: {
      "click": function($event) {
        _vm.employeeWorkingFieldName = 'Lærling'
      }
    }
  }, [_vm._v("\n            Lærlinge\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "employees.timeUsage"
    }
  }), _vm._v("\n                    Opsummering\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('pie', {
    attrs: {
      "headline": "Hvad bruger vi tiden på?",
      "series": _vm.hoursDivision.series,
      "labels": _vm.hoursDivision.labels,
      "division": true,
      "height": "220px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('pie', {
    attrs: {
      "headline": "Fordeling af tid hos kunderne",
      "series": _vm.hoursWithCustomers.series,
      "labels": _vm.hoursWithCustomers.labels,
      "division": false,
      "height": "220px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [(_vm.hoursWithoutCustomers.labels && _vm.hoursWithoutCustomers.labels.length > 0) ? _c('pie', {
    attrs: {
      "headline": "Fordeling af anden tid",
      "series": _vm.hoursWithoutCustomers.series,
      "labels": _vm.hoursWithoutCustomers.labels,
      "division": false,
      "height": "220px"
    }
  }) : _c('div', [_c('div', {
    staticClass: "headline",
    staticStyle: {
      "text-align": "center",
      "font-weight": "600",
      "font-family": "'Open Sans', sans-serif"
    }
  }, [_vm._v("\n                                    Fordeling af anden tid\n                                ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('br'), _vm._v("\n                                    Ingen anden tid registreret\n                                ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [(_vm.hoursExcluded.labels && _vm.hoursExcluded.labels.length > 0) ? _c('pie', {
    attrs: {
      "headline": "Fordeling af fravær",
      "series": _vm.hoursExcluded.series,
      "labels": _vm.hoursExcluded.labels,
      "division": false,
      "height": "220px"
    }
  }) : _c('div', [_c('div', {
    staticClass: "headline",
    staticStyle: {
      "text-align": "center",
      "font-weight": "600",
      "font-family": "'Open Sans', sans-serif"
    }
  }, [_vm._v("\n                                    Fordeling af fravær\n                                ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('br'), _vm._v("\n                                    Intet fravær registreret\n                                ")])])], 1)]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])])]), _vm._v(" "), _c('employee-time-usage', {
    attrs: {
      "employeeWorkingFieldName": _vm.employeeWorkingFieldName
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06c72782"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/employees/learning/timeUsage.vue
// module id = 793
// module chunks = 0